import { walletAddressSlicer } from "../utils/util";
const ToastMsg = ({ receipt, type }) => {
  return (
    <>
      <p className="big">
        <span className="key">Your Receipt</span>
      </p>
      <p className="toastmsg-text">
        <span className="key">TransactionHash: </span>{" "}
        <a
          href={`https://polygonscan.com/tx/${receipt.transactionHash}`}
          target="_blank"
        >
          <b className="value">
            {" "}
            {walletAddressSlicer(receipt.transactionHash)}
          </b>
        </a>
      </p>
      <p className="toastmsg-text">
        <span className="key">Status:</span>{" "}
        <b className="value">{receipt.status && "Success"}</b>
      </p>
      <p className="toastmsg-text">
        <span className="key">BlockNumber:</span>{" "}
        <b className="value">{receipt.blockNumber}</b>
      </p>
      <a
        className="receipt-btn"
        href={`https://polygonscan.com/tx/${receipt.transactionHash}`}
        target="_blank"
      >
        Show More
      </a>
    </>
  );
};

export default ToastMsg;
